import FqApi from '@/services/fq-api'
import ProtoBuf from 'protobufjs'

export default {
  async getEntity(id) {
    const url = `/countries/${id}`
    const result = await FqApi.get(url)
    return result.data
  },
  async getEntitySummaries(filter) {
      const serialised = this.serialiseCountryFilter(filter)
      const url = `/countries/list/${serialised}`
      const result = await FqApi.get(url)
      return result.data
    },
  serialiseCountryFilter(filter) {
      const entityProto = require('../../../assets/proto/country/CountryFilter.proto')
      const filterMessage = entityProto.CountryFilter.CountryFilterModel
      const buffer = filterMessage.encode(filter).finish()
      const b64encoded = ProtoBuf.util.base64.encode(buffer, 0, buffer.length)
      return b64encoded
  },
  putCountrySetting(entity, deepDiff) {
    if (deepDiff) {
      entity.deepDiff = JSON.stringify(deepDiff)
    }
    return FqApi.put(`/countries/${entity.countryId}`, entity)
  },
  async postCountrySetting(entity) {
    return FqApi.post('/countries', entity)
  },
  async getNewEntity() {
    const result = await FqApi.get('/countries/new')
    return result.data
  },
  async checkcountrycodevalidity(id, countryCode) {
      const result = await FqApi.get(`/countries/checkcountrycodevalidity/${id}/${countryCode}`)
      return result.data
  }
}
